/* 取送洗衣 */

import { GET, POST, download, uploading, POSTFormData } from '@/request/http'

// 分页查询订单
export const laundry_getOrderTable = p => POST('/laundry/order/pagedetail', p)



// WEBPACK FOOTER //
// ./src/api/modules/takeToSendLaundry.js